import React from 'react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="depoimentos" className="section-padding">
      <div className="container-custom">
        <h2 className="section-title">Depoimentos</h2>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <p className="testimonial-text">"{testimonial.text}"</p>
              <p className="testimonial-author">— {testimonial.author}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;